
import * as api from '../api/index'
import { getOrCreateSubscription } from '../helper';

import { AUTH, CREATE_PROFILE ,FETCH_USERS,START_LOADING,END_LOADING, DELETE_USER,UPDATE_USER} from './constants'


export const getUsers = () => async (dispatch) => {
    try {
  
      dispatch({ type: START_LOADING })
      const { data } = await api.fetchUsers();
    
      //  console.log(data.email)
      dispatch({ type: FETCH_USERS, payload: data });
      dispatch({ type: END_LOADING })
  
    } catch (error) {
      console.log(error);
    } };

export const deleteUser = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteUser(id);
    dispatch({ type: DELETE_USER, payload: id });
    openSnackbar("User deleted successfully");
  } catch (error) {
    console.log(error);
  }
};
export const updateUser = (id, form, openSnackbar) => async (dispatch) => {
    try {
      // Toggle the isActive value
      const { data } = await api.updateUser(id, form);
      dispatch({ type: UPDATE_USER, payload: data });
      openSnackbar("User updated successfully");
    } catch (error) {
      console.log(error);
    }
  };

export const changeUserPassword = (id, newPassword, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.changePassword(id, newPassword);
    openSnackbar(data.message || "Password changed successfully");
  } catch (error) {
    console.log(error);
    openSnackbar(error?.response?.data?.message || "Failed to change password");
  }
};
  // export const updateAdminDeviceId = (form, openSnackbar) => async (dispatch) => {
  //   try {
     
  //     // Toggle the isActive value
  //     const { data } = await api.updateAdminDeviceId(form);
  //     console.log(data);
  //      dispatch({ type: UPDATE_USER, payload: data });
  //     openSnackbar("Device Id Added successfully");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }; 
export const updateAdminDeviceId = (id, form, openSnackbar) => async (dispatch) => {
    try {
      // Toggle the isActive value
      const { data } = await api.updateAdminDeviceId(id, form);
      const incomingDeviceId = Array.isArray(form?.deviceId)
        ? form.deviceId[0]
        : form?.deviceId;
      if (typeof incomingDeviceId === "string" && incomingDeviceId) {
        localStorage.setItem("currentDeviceId", incomingDeviceId);
      }
       dispatch({ type: UPDATE_USER, payload: data });
      openSnackbar("Device Id Added successfully");
    } catch (error) {
      console.log(error);
    }
  }; 

export const removeAdminDeviceId = (id, deviceId) => async () => {
  if (!id || !deviceId) return;
  try {
    await api.removeAdminDeviceId(id, deviceId);
  } catch (error) {
    console.warn("Failed to remove device token during logout:", error);
  }
};

export const logoutUser = () => async (dispatch) => {
  const currentDeviceId =
    window.__CURRENT_DEVICE_ID__ ||
    localStorage.getItem("currentDeviceId") ||
    localStorage.getItem("pendingDeviceId");

  try {
    await api.logoutUser({ deviceId: currentDeviceId || undefined });
  } catch (error) {
    console.warn("Logout API call failed, continuing local logout:", error);
  } finally {
    dispatch({ type: "LOGOUT" });
  }
};
// export const adminSignin =(formData, openSnackbar, setLoading) => async(dispatch) => {

//     try {
//         //login the user
//         const { data } = await api.adminSignIn(formData)
//         (data)
//         dispatch({ type: AUTH, data})
//         // const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
//         // dispatch({ type: CREATE_PROFILE, payload: info });
//             // setLoading(false)
//         openSnackbar("Admin Signin successfull")
//         // history.push('/dashboard')
//         window.location.href="/adminDashboard"

//     } catch (error) {
//          console.log(error?.response?.data?.message)
//         openSnackbar(error?.response?.data?.message)
//         setLoading(false)
//     }
// }

export const adminSignup =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //Sign up the user
        console.log('Admin Sign up Calling Action')
        const { data } = await api.adminSignUp(formData)
        // dispatch({ type: AUTH, data})
        const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
        dispatch({ type: CREATE_PROFILE, payload: info });
        // window.location.href="../"
         openSnackbar("user created successfully")
         setLoading(false) // Reset loading state on success
       setTimeout(() => {
         window.location.reload();
       }, 2000);
        // history.push('/dashboard')
        

    } catch (error) {
        console.log(error)
        openSnackbar(error?.response?.data?.message)
        setLoading(false)
    }
}


export const signin =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //login the user
        const { data } = await api.signIn(formData)
        //
        dispatch({ type: AUTH, data})
        // Save web-push subscription for this user (dealer/salesman/admin)
        try {
          const userId = data?.result?._id;
          if (userId) {
            const subscription = await getOrCreateSubscription();
            if (subscription) {
              await api.updateUserSubscription(userId, { subscription });
            }
            const pendingDeviceId = localStorage.getItem("pendingDeviceId");
            if (pendingDeviceId) {
              await api.updateAdminDeviceId(userId, { deviceId: pendingDeviceId });
              localStorage.setItem("currentDeviceId", pendingDeviceId);
              localStorage.removeItem("pendingDeviceId");
            }
          }
        } catch (err) {
          console.warn("Failed to save subscription:", err);
        }
        // const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
        // dispatch({ type: CREATE_PROFILE, payload: info });
        setLoading(false) // Reset loading state on success
        openSnackbar("Signin successfull")
        // history.push('/dashboard')
        
        // Check user type and redirect accordingly
        if (data?.result?.userType === "dealer") {
            window.location.href = "/invoices"
        } else {
            window.location.href = "/dashboard"
        }

    } catch (error) {
         console.log(error?.response?.data?.message)
        openSnackbar(error?.response?.data?.message)
        setLoading(false)
    }
}

export const signup =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //Sign up the user
        const { data } = await api.signUp(formData)
        // dispatch({ type: AUTH, data})
        const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
        dispatch({ type: CREATE_PROFILE, payload: info });
        
      setTimeout(() => {
          window.location.reload();
      }, 1000);
        // history.push('/dashboard')
        openSnackbar("Sign up successfull")

    } catch (error) {
        console.log(error)
        openSnackbar(error?.response?.data?.message)
        setLoading(false)
    }
}



export const forgot =(formData) => async(dispatch) => {
    try {
        await api.forgot(formData)
    } catch (error) {
        console.log(error)
    }
}


export const reset =(formData, history) => async(dispatch) => {

    try {
        await api.reset(formData)
        history.push('/login')

    } catch (error) {
        alert(error)
    }
}
